<template>
    <span class="app-nav-icon text-text">
        <SvgIcon
            v-if="icon === '/dashboard'"
            classes="dashboard-icon"
            width="20px"
            height="18px"
            icon="dashboard-icon"
        />

        <SvgIcon
            v-else-if="icon === '/locations'"
            classes="locations-icon"
            width="20px"
            height="20px"
            icon="locations-icon"
        />

        <SvgIcon
            v-else
            classes="hog-icon"
            width="24px"
            height="24px"
            icon="hog-icon"
        />
    </span>
</template>

<script>
import SvgIcon from "../UI/SvgIcon";
export default {
    name: "NavigationIcons",
    components: { SvgIcon },
    props: ["icon"]
};
</script>
